import {
  POST,
  GET,
  GETPDF
} from '@/axios/axios'

export const services = {
  cooperationList: (param) => { // 商户合作信息
    return GET("/backend/customCollection/queryByPage", param);
  },
  cooperationEdit: (param) => { // 商户合作修改状态
    return POST("/backend/customCollection/updateIsContact", param);
  },
  cooperationExport: (param, rsType) => { //  商户合作导出
    return GETPDF("/backend/customCollection/export", param, rsType);
  }
}

export default services;



// WEBPACK FOOTER //
// ./src/service/services/webpage.js